import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import Select from "react-select";
import Swal from "sweetalert2";

import Layouts from "../../layouts/layouts";

export default function Create_vehicleonboard() {
  const title = "Add Vehicle On-board";
  const [formData, setFormData] = useState({
    temp_number: "",
    date: "",
    vehicle_type: "",
    size: "",
    leasing_partner: "",
    location: "",
    client: "",
    handover_supervisor: "",
    comments: "",
    currentKm: 0,
    serviceCompleted: false,
    lastServiceKm: 0,
    lastServiceDate: "",
    lastServiceType: "",
  });
  const [autocomplete, setAutocomplete] = useState(null);
  const [errors, setErrors] = useState({});
  const [clients, setClients] = useState([]);
  const [users, setUsers] = useState([]);
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [additionalThings, setAdditionalThings] = useState([]);
  const [availableThings, setAvailableThings] = useState([]);
  const [selectedThing, setSelectedThing] = useState("");
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [newThingName, setNewThingName] = useState("");
  const [showNewThingInput, setShowNewThingInput] = useState(false);

  const navigate = useNavigate();

  const brad = [{ name: "Home" }, { name: title }];
  const onChangeHandler = (event) => {
    const { name, value } = event.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const onLoad = (autoComp) => {
    setAutocomplete(autoComp);
  };

  useEffect(() => {
    fetchAdditionalThings();
  }, []);

  const fetchAdditionalThings = async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v4/additional-things`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setAvailableThings(response.data.data || []);
    } catch (error) {
      console.error("Error fetching additional things:", error);
    }
  };

  useEffect(() => {
    const fetchVehicleTypes = async () => {
      try {
        const token = localStorage.getItem("token");

        if (!token) {
          console.error("No token found");
          return;
        }

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/vehicle-types`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (response.data && response.data.vehicleType) {
          setVehicleTypes(response.data.vehicleType);
        } else {
          console.error("Unexpected response format:", response.data);
          setVehicleTypes([]);
        }
      } catch (error) {
        console.error("Error fetching vehicle types:", error);
        setVehicleTypes([]);
      }
    };

    fetchVehicleTypes();
  }, []);

  const handleVehicleTypeChange = (selectedOption) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      vehicle_type: selectedOption ? selectedOption.value : "",
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.temp_number)
      newErrors.temp_number = "Vehicle Number is required";
    if (!formData.date) newErrors.date = "Date is required";
    if (!formData.leasing_partner)
      newErrors.leasing_partner = "Leasing Partner is required";
    if (!formData.location) newErrors.location = "Location is required";
    if (!formData.client) newErrors.client = "Client is required";

    if (!formData.handover_supervisor)
      newErrors.handover_supervisor = "Handover Supervisor is required";

    if (!formData.vehicle_type)
      newErrors.vehicle_type = "Vehicle Type is required";
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const onSubmitHandler = async (event) => {
    event.preventDefault();
    console.log("Submit button clicked");
    if (!validateForm()) {
      console.log("Not a validate form");
      return;
    }

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }

      const formDataToSubmit = new FormData();
      formDataToSubmit.append("temp_number", formData.temp_number);
      formDataToSubmit.append("date", formData.date);
      formDataToSubmit.append("vehicle_type", formData.vehicle_type);
      formDataToSubmit.append("size", formData.size);
      formDataToSubmit.append("leasing_partner", formData.leasing_partner);
      formDataToSubmit.append("location", formData.location);
      formDataToSubmit.append("client", formData.client);
      formDataToSubmit.append("currentKm", formData.currentKm);
      formDataToSubmit.append("serviceCompleted", formData.serviceCompleted);
      formDataToSubmit.append("lastServiceKm", formData.lastServiceKm);
      if (formData.lastServiceType) {
        formDataToSubmit.append("lastServiceType", formData.lastServiceType);
      }

      if (formData.lastServiceDate) {
        formDataToSubmit.append("lastServiceDate", formData.lastServiceDate);
      }
      formDataToSubmit.append("comments", formData.comments);
      formDataToSubmit.append(
        "handover_supervisor",
        formData.handover_supervisor,
      );

      const additionalThingsData = additionalThings.map((item, index) => ({
        thing: item.thing,
        photoIndex: index,
      }));

      formDataToSubmit.append(
        "additionalThings",
        JSON.stringify(additionalThingsData),
      );

      additionalThings.forEach((item) => {
        if (item.photo) {
          formDataToSubmit.append("additionalThingPhotos", item.photo);
        }
      });

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v4/vehicle-onboarding`,
        formDataToSubmit,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 201) {
        navigate("/vehicleonboard");
      } else {
        console.error("Submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/admin/users`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setUsers(response.data.users);
      } catch (error) {
        console.error("Error fetching users:", error);
        setUsers([]);
      }
    };
    fetchUsers();
  }, []);
  const handleUserChange = (selectedOption) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      handover_supervisor: selectedOption ? selectedOption.value : "",
    }));
  };

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/clients`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setClients(response.data.clients);
      } catch (error) {
        console.error("Error fetching client:", error);
        setClients([]);
      }
    };
    fetchClients();
  }, []);
  const handleClientChange = (selectedOption) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      client: selectedOption ? selectedOption.value : "",
    }));
  };

  const handleAddAdditionalThing = async () => {
    try {
      if (!selectedPhoto) {
        Swal.fire("Error", "Please upload a photo", "error");
        return;
      }

      let thingId = selectedThing;
      let thingName = "";

      // New thing
      if (showNewThingInput) {
        if (!newThingName.trim()) {
          Swal.fire("Error", "Please enter thing name", "error");
          return;
        }

        const token = localStorage.getItem("token");

        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/api/v4/additional-things`,
          {
            name: newThingName.trim(),
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        thingId = response.data.data._id;
        thingName = response.data.data.name;

        // Refresh dropdown
        fetchAdditionalThings();
      } else {
        const selected = availableThings.find(
          (item) => item._id === selectedThing,
        );

        if (!selected) {
          Swal.fire("Error", "Please select an additional thing", "error");
          return;
        }

        thingName = selected.name;
      }

      const photoPreview = URL.createObjectURL(selectedPhoto);

      setAdditionalThings((prev) => [
        ...prev,
        {
          thing: thingId,
          name: thingName,
          photo: selectedPhoto,
          photoPreview,
          photoUrl: null,
        },
      ]);

      // Reset
      setSelectedThing("");
      setSelectedPhoto(null);
      setNewThingName("");
      setShowNewThingInput(false);
    } catch (error) {
      console.error(error);

      Swal.fire("Error", "Could not add additional thing", "error");
    }
  };

  const removeAdditionalThing = (index) => {
    setAdditionalThings((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <>
      <Layouts />
      <div className="container-fluid">
        <Breadcrumb title={title} brad={brad} />
        <form
          className="card"
          style={{ borderTop: "2px solid #4723d9" }}
          onSubmit={onSubmitHandler}
        >
          <div className="card-header d-flex justify-content-between border-bottom pb-1">
            <div className="">{title}</div>
            <div className="btn btn-info btn-sm" onClick={() => navigate(-1)}>
              Back
            </div>
          </div>
          <div className="card-body">
            <div className="row justify-content-center">
              <div className="col-md-6 mt-3">
                <label htmlFor="temp_number">
                  <b>Number Plate *</b>
                </label>
                <input
                  type="text"
                  name="temp_number"
                  placeholder="Vehicle Number"
                  className="form-control"
                  value={formData.temp_number}
                  onChange={onChangeHandler}
                />
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="vehicle_type">
                  <b>Vehicle Type *</b>
                </label>

                <Select
                  name="vehicle_type"
                  options={vehicleTypes.map((vehicle) => ({
                    value: vehicle._id,
                    label: `${vehicle.company || ""} / ${vehicle.feet || 0}`,
                  }))}
                  value={
                    vehicleTypes
                      .map((vehicle) => ({
                        value: vehicle._id,
                        label: `${vehicle.company || ""} / ${vehicle.feet || 0}`,
                      }))
                      .find(
                        (option) => option.value === formData.vehicle_type,
                      ) || null
                  }
                  onChange={handleVehicleTypeChange}
                  placeholder="Select Vehicle Type"
                  isClearable
                  classNamePrefix="select"
                />

                {errors.vehicle_type && (
                  <p className="text-danger">{errors.vehicle_type}</p>
                )}
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="to">
                  <b>On-Boarding Date *</b>
                </label>
                <input
                  type="date"
                  name="date"
                  className="form-control"
                  value={formData.date}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="client">
                  <b>Assign Client *</b>
                </label>
                <Select
                  name="client"
                  options={clients.map((client) => ({
                    value: client._id,
                    label: `${client.name}`,
                  }))}
                  onChange={handleClientChange} // Use the specific handler
                  classNamePrefix="select"
                />
                {errors.client && (
                  <div className="invalid-feedback">{errors.client}</div>
                )}
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="leasing_partner">
                  <b>Leasing Partner *</b>
                </label>
                <input
                  type="text"
                  name="leasing_partner"
                  placeholder="Leasing Partner"
                  className="form-control"
                  value={formData.leasing_partner}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="location">
                  <b>Location (City) *</b>
                </label>
                <input
                  type="text"
                  name="location"
                  placeholder="Location"
                  className="form-control"
                  value={formData.location}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="handover_supervisor">
                  <b> Handover Supervisor* </b>
                </label>
                <Select
                  name="handover_supervisor"
                  options={users.map((user) => ({
                    value: user._id,
                    label: `${user.name || "Unknown Name"} (${
                      user.phonenumber || "Unknown Phone"
                    })`,
                  }))}
                  onChange={handleUserChange}
                  classNamePrefix="select"
                />
                {errors.handover_supervisor && (
                  <p className="text-danger">{errors.handover_supervisor}</p>
                )}
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="size">
                  <b>Size *</b>
                </label>
                <input
                  type="text"
                  name="size"
                  placeholder="Size"
                  className="form-control"
                  value={formData.size}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="currentKm">
                  <b>Current KM *</b>
                </label>
                <input
                  type="number"
                  name="currentKm"
                  placeholder="Current KM"
                  className="form-control"
                  min="0"
                  value={formData.currentKm}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="serviceCompleted">
                  <b>Service Completed *</b>
                </label>

                <Select
                  name="serviceCompleted"
                  options={[
                    { value: false, label: "No" },
                    { value: true, label: "Yes" },
                  ]}
                  value={{
                    value: formData.serviceCompleted,
                    label: formData.serviceCompleted ? "Yes" : "No",
                  }}
                  onChange={(selectedOption) =>
                    setFormData((prevFormData) => ({
                      ...prevFormData,
                      serviceCompleted: selectedOption
                        ? selectedOption.value
                        : false,
                    }))
                  }
                  classNamePrefix="select"
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="lastServiceKm">
                  <b>Last Service KM</b>
                </label>

                <input
                  type="number"
                  name="lastServiceKm"
                  placeholder="Last Service KM"
                  className="form-control"
                  min="0"
                  value={formData.lastServiceKm}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="lastServiceDate">
                  <b>Last Service Date</b>
                </label>

                <input
                  type="date"
                  name="lastServiceDate"
                  className="form-control"
                  value={formData.lastServiceDate}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="lastServiceType">
                  <b>Last Service Type</b>
                </label>

                <Select
                  name="lastServiceType"
                  options={[
                    { value: "First", label: "First" },
                    { value: "Second", label: "Second" },
                    { value: "Third", label: "Third" },
                    { value: "Fixed", label: "Fixed" },
                  ]}
                  value={
                    formData.lastServiceType
                      ? {
                          value: formData.lastServiceType,
                          label: formData.lastServiceType,
                        }
                      : null
                  }
                  onChange={(selectedOption) =>
                    setFormData((prevFormData) => ({
                      ...prevFormData,
                      lastServiceType: selectedOption
                        ? selectedOption.value
                        : "null",
                    }))
                  }
                  placeholder="Select Last Service Type"
                  isClearable
                  classNamePrefix="select"
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="comments">
                  <b>Comments </b>
                </label>
                <input
                  type="text"
                  name="comments"
                  placeholder="Comments"
                  className="form-control"
                  value={formData.comments}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="card mt-3">
                <div className="card-header">
                  <h5>
                    <b>Additional Things</b>
                  </h5>
                </div>

                <div className="card-body">
                  <div className="row">
                    <div className="col-md-5">
                      <label>Additional Thing</label>

                      <select
                        className="form-control"
                        value={selectedThing}
                        onChange={(e) => {
                          if (e.target.value === "ADD_NEW") {
                            setShowNewThingInput(true);
                            setSelectedThing("");
                          } else {
                            setShowNewThingInput(false);
                            setSelectedThing(e.target.value);
                          }
                        }}
                      >
                        <option value="">Select Additional Thing</option>

                        {availableThings.map((thing) => (
                          <option key={thing._id} value={thing._id}>
                            {thing.name}
                          </option>
                        ))}

                        <option value="ADD_NEW">+ Add New</option>
                      </select>
                    </div>

                    {showNewThingInput && (
                      <div className="col-md-5">
                        <label>New Thing</label>

                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter thing name"
                          value={newThingName}
                          onChange={(e) => setNewThingName(e.target.value)}
                        />
                      </div>
                    )}

                    <div className="col-md-5">
                      <label>Photo</label>

                      <input
                        type="file"
                        className="form-control"
                        accept="image/*"
                        onChange={(e) => setSelectedPhoto(e.target.files[0])}
                      />
                    </div>

                    <div className="col-md-2 d-flex align-items-end">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleAddAdditionalThing}
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {additionalThings.length > 0 && (
                <div className="table-responsive mt-4">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Additional Thing</th>
                        <th>Photo</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {additionalThings.map((item, index) => (
                        <tr key={index}>
                          <td>{item.name}</td>

                          <td>
                            {item.photoPreview && (
                              <img
                                src={item.photoPreview}
                                alt={item.name}
                                style={{
                                  width: "70px",
                                  height: "70px",
                                  objectFit: "cover",
                                }}
                              />
                            )}
                          </td>

                          <td>
                            <button
                              type="button"
                              className="btn btn-danger btn-sm"
                              onClick={() => removeAdditionalThing(index)}
                            >
                              Remove
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              <div className="col-md-6 mt-3"></div>
            </div>
            <button type="submit" className="btn btn-primary btn-sm mt-3">
              Add Vehicle On-Board
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
